import {ZadSaleSettlement, ZadSaleSettlementStatus} from '../../../models/zad'

export const ZAD_SALE_SETTLEMENT_I18N: Record<ZadSaleSettlementStatus, string> = {
  UNPAID: 'ZAD.SALES.SETTLEMENT_UNPAID',
  PARTIAL: 'ZAD.SALES.SETTLEMENT_PARTIAL',
  SETTLED: 'ZAD.SALES.SETTLEMENT_SETTLED',
}

export function normalizeZadSaleSettlementStatus(
  raw?: string | null
): ZadSaleSettlementStatus | null {
  const value = String(raw || '').toUpperCase()
  if (value === 'UNPAID' || value === 'PARTIAL' || value === 'SETTLED') return value
  return null
}

function settlementRecord(value: unknown): Record<string, any> | null {
  return value && typeof value === 'object' ? (value as Record<string, any>) : null
}

export function readZadSaleSettlement(source?: unknown): ZadSaleSettlement | null {
  if (source == null || source === '') return null
  if (typeof source === 'string') {
    const status = normalizeZadSaleSettlementStatus(source)
    return status
      ? {status, saleAmount: Number.NaN, paidAmount: Number.NaN, remainingAmount: Number.NaN}
      : null
  }
  const obj = settlementRecord(source)
  if (!obj) return null
  const ownStatus = normalizeZadSaleSettlementStatus(obj.status)
  const nested = ownStatus || obj.saleAmount != null ? obj : obj.settlement
  if (nested == null || nested === '') return null
  if (typeof nested === 'string') {
    const status = normalizeZadSaleSettlementStatus(nested)
    return status
      ? {status, saleAmount: Number.NaN, paidAmount: Number.NaN, remainingAmount: Number.NaN}
      : null
  }
  const raw = settlementRecord(nested)
  if (!raw) return null
  const status = normalizeZadSaleSettlementStatus(raw.status || raw.settlement)
  if (!status) return null
  const hasAmounts =
    raw.saleAmount != null && raw.paidAmount != null && raw.remainingAmount != null
  return {
    status,
    saleAmount: hasAmounts ? Number(raw.saleAmount) : Number.NaN,
    paidAmount: hasAmounts ? Number(raw.paidAmount) : Number.NaN,
    remainingAmount: hasAmounts ? Number(raw.remainingAmount) : Number.NaN,
    allocated: raw.allocated,
    outstanding: raw.outstanding,
    saleTotal: raw.saleTotal,
    validatedReturnsTotal: raw.validatedReturnsTotal,
    netSaleTotal: raw.netSaleTotal,
  }
}

export function isZadSaleSettlementApplicable(status?: string | null): boolean {
  return String(status || '').toUpperCase() === 'VALIDATED'
}

export function zadSaleSettlementHasAmounts(settlement?: ZadSaleSettlement | null): boolean {
  return Boolean(
    settlement &&
      Number.isFinite(settlement.saleAmount) &&
      Number.isFinite(settlement.paidAmount) &&
      Number.isFinite(settlement.remainingAmount)
  )
}

export function zadSaleSettlementBadgeClass(status?: ZadSaleSettlementStatus | null): string {
  if (status === 'PARTIAL') return 'badge badge-light-warning'
  if (status === 'SETTLED') return 'badge badge-light-success'
  if (status === 'UNPAID') return 'badge badge-light-primary'
  return 'badge badge-light'
}
